module.exports = __webpack_public_path__ + "static/media/001A_infopanel.160b0323.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/google/001A_infopanel.png
// module id = 457
// module chunks = 0